import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ palette,variables }) => ({
  ordeFilterWrapper: {
   padding: `${variables?.spacingD}`,
   paddingBottom: variables?.spacingNone,
  },
  orderFilterItemContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: variables?.spacingB,
    padding:variables?.spacingB
  },
  orderFilterTabs: {
    display: 'flex',
    minHeight:'auto',
    justifyContent: 'center'
  },
  orderFilterScrollButtons: {
    //width:'auto'
    display:'flex',
    alignItems: 'center',
    padding: '0px 4px',
    width:'32px',
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize:'1.7rem',
    },
    '& .MuiSvgIcon-root': {
      fill: palette.jet?.interactiveBrand
    }
  },
  orderFilterButton: {
    minWidth: '41px !important',
    width:'auto'
  }

}));

export default styles;
